export const CONNECT_LINKS = [
  {
    contains: 'strava',
    name: 'Strava',
    icon: 'strava',
  },
  {
    contains: 'connect.garmin.com',
    name: 'Garmin connect',
    icon: 'garmin',
  },
  {
    contains: 'flow.polar',
    name: 'Polar Flow',
    icon: 'polarFlow',
  },
  {
    contains: 'movescount',
    name: 'Movescount',
    icon: 'movescountSuunto',
  },
  {
    contains: 'suunto',
    name: 'Suunto',
    icon: 'movescountSuunto',
  },
  {
    contains: 'mapmy',
    name: 'Endomondo',
    icon: 'endomondo',
  },
  {
    contains: 'runkeeper',
    name: 'Runkeeper',
    icon: 'runkeeper',
  },
  {
    contains: 'sports-tracker',
    name: 'Sports Tracker',
    icon: 'sporsTracker',
  },
  {
    contains: 'wahoo',
    name: 'Wahoo',
    icon: 'wahoo',
  },
  {
    contains: 'raceone',
    name: 'RaceONE',
    icon: 'raceone',
  },
  {
    contains: 'zwift',
    name: 'Zwift',
    icon: 'zwift',
  },
];

export const DEFAULT_LINK = {
  name: 'Activity Link',
  icon: 'common',
};

export const NO_SOURCE_LINK = {
  name: 'No source',
  icon: 'noSource',
};
